import {
	AdminUpdateEmailsModalComponent,
	AdminPermissionsModalComponent,
	AdminInviteUserModalComponent,
	AdminCreateOrgModalComponent,
	AdminRecollectModalComponent,
	AdminRenameOrgModalComponent,
	AdminRawJsonModalComponent,
	AdminAssignModalComponent,
	AdminDeleteModalComponent,
} from '@modules/admin-panel/modals';
import { AdminOrgCollectionComponent } from '@modules/admin-panel/modals/admin-org-collection/admin-org-collection.component';
import { IAdminModalTypes } from '@modules/admin-panel/domain/models/admin-modal';
import { AdminModalItem } from '@modules/admin-panel/domain/admin-modal-item';
import { ModalService } from '@app/services/modal.service';
import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-shell-admin-panel',
	templateUrl: './shell-admin-panel.component.html',
	styleUrls: ['./shell-admin-panel.component.scss'],
})
export class ShellAdminPanelComponent implements OnInit {
	constructor(private modalService: ModalService) {}

	public ngOnInit(): void {
		// hack for fix console error - @Todo: refactor all modals and remove this hack
		setTimeout(() => {
			this.modalService.modals = this.getModals();
		}, 100);
	}

	private getModals(): AdminModalItem[] {
		return [
			new AdminModalItem(AdminCreateOrgModalComponent, {
				title: 'Create Organization',
				type: IAdminModalTypes.createOrganization,
			}),
			new AdminModalItem(AdminDeleteModalComponent, {
				title: 'Delete Organization',
				type: IAdminModalTypes.deleteOrganization,
			}),
			new AdminModalItem(AdminUpdateEmailsModalComponent, {
				title: 'Update Emails',
				type: IAdminModalTypes.updateOrganizationEmails,
			}),
			new AdminModalItem(AdminRecollectModalComponent, {
				title: 'Recollect Dashboard',
				type: IAdminModalTypes.recollectOrganization,
			}),
			new AdminModalItem(AdminRawJsonModalComponent, {
				title: 'Raw',
				type: IAdminModalTypes.rawJson,
			}),
			new AdminModalItem(AdminAssignModalComponent, {
				type: IAdminModalTypes.assignOrganization,
			}),
			new AdminModalItem(AdminOrgCollectionComponent, {
				title: 'Update Custom Collection Cycle',
				type: IAdminModalTypes.customCollectionCycle,
			}),
			new AdminModalItem(AdminPermissionsModalComponent, {
				title: 'Account Permissions',
				type: IAdminModalTypes.accountPermissions,
			}),
			new AdminModalItem(AdminRenameOrgModalComponent, {
				title: 'Rename Organization',
				type: IAdminModalTypes.renameOrganization,
			}),
			new AdminModalItem(AdminInviteUserModalComponent, {
				title: 'Assign user',
				type: IAdminModalTypes.inviteUser,
			}),
		];
	}
}
